export default __webpack_public_path__ + "static/media/workout.e5bf39f4.jpg";